export default __webpack_public_path__ + "images/9082177d266cee25a57b5216185ae8c2.png";